import { Button, Card, CircularProgress, Grid, InputLabel, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../components';
import { getDetailDataHero, updDataHero } from '../../../redux/actions/HeroActions';

const EditSertifikat = () => {
    const { id } = useParams();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [params, setParams] = useState({
        menu_code: "",
        type: "",
        img_mobile_ori: "",
        img_mobile: "",
        img_mobile_preview: "",
        img_desktop_ori: "",
        img_desktop: "",
        img_desktop_preview: "",
        title_en: "",
        title_id: "",
        subtitle_en: "",
        subtitle_id: "",
        meta_title_id: "",
        meta_title_en: "",
        meta_desc_id: "",
        meta_desc_en: "",
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        updDataHero(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = useCallback((text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    }, [history]);
    const handleChangeFoto = (name, file) => {
        setParams((pref) => ({
            ...pref,
            [name]: file,
            [name+"_preview"]: file
        }));
    };
    const getData = useCallback(() => {
        setLoading(true);
        getDetailDataHero(id)
            .then((res) => {
                let data = res.data?.data;
                if (Object.keys(data).length > 0) {
                    setParams((pref) => ({
                        ...pref,
                        menu_code: data?.menu_code,
                        type: data?.type,
                        img_mobile_ori: data?.img_mobile_ori,
                        img_mobile: "",
                        img_mobile_preview: data?.img_mobile,
                        img_desktop_ori: data?.img_desktop_ori,
                        img_desktop: "",
                        img_desktop_preview: data?.img_desktop,
                        title_en: data?.title_en,
                        title_id: data?.title_id,
                        subtitle_en: data?.subtitle_en,
                        subtitle_id: data?.subtitle_id,
                        meta_title_id: data?.meta_title_id,
                        meta_title_en: data?.meta_title_en,
                        meta_desc_id: data?.meta_desc_id,
                        meta_desc_en: data?.meta_desc_en,
                    }));
                } else {
                    showAlert(
                        'Gagal mengambil detail data, coba beberapa saat lagi',
                        false
                    );
                }
                setLoading(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal mengambil detail data, coba beberapa saat lagi',
                    false
                );
                setLoading(false);
            });
    }, [id, showAlert]);
    useEffect(() => {
        setParams((pref) => ({
            ...pref,
            type: id
        }));
        getData();
    }, [getData, id]);
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Edit Hero Section</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        {loading ? (
                            <div className="text-center">
                                <CircularProgress color="primary" size={35} />
                            </div>
                        ) : (
                            <ValidatorForm
                                onSubmit={handleFormSubmit}
                                className="w-full"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <UploadImage
                                            uploadFoto={(file) => handleChangeFoto("img_desktop", file)}
                                            label="Unggah Foto Untuk Desktop"
                                            preview={
                                                params?.img_desktop_preview
                                            }
                                            required={true}
                                            noCrop={true}
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 1440 x 617'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <UploadImage
                                            uploadFoto={(file) => handleChangeFoto("img_mobile", file)}
                                            label="Unggah Foto Untuk Mobile"
                                            preview={
                                                params?.img_mobile_preview
                                            }
                                            noCrop={true}
                                            required={true}
                                            note={[
                                                'Format PNG, WEBP dan JPG diperbolehkan',
                                                '*Ukuran foto 767 x 500'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="title_id"
                                            className="mb-4"
                                        >
                                            Judul [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="title_id"
                                            placeholder="Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="title_id"
                                            value={params.title_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="title_en"
                                            className="mb-4"
                                        >
                                            Judul [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="title_en"
                                            placeholder="Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="title_en"
                                            value={params.title_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="subtitle_id"
                                            className="mb-4"
                                        >
                                            Sub Judul [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="subtitle_id"
                                            placeholder="Sub Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="subtitle_id"
                                            value={params.subtitle_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Sub Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="subtitle_en"
                                            className="mb-4"
                                        >
                                            Sub Judul [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="subtitle_en"
                                            placeholder="Sub Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="subtitle_en"
                                            value={params.subtitle_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Sub Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_title_id"
                                            className="mb-4"
                                        >
                                            Meta Judul [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_title_id"
                                            placeholder="Meta Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_title_id"
                                            value={params.meta_title_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_title_en"
                                            className="mb-4"
                                        >
                                            Meta Judul [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_title_en"
                                            placeholder="Meta Judul"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_title_en"
                                            value={params.meta_title_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Judul terlebih dahulu'
                                            ]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_desc_id"
                                            className="mb-4"
                                        >
                                            Meta Deskripsi [ID]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_desc_id"
                                            placeholder="Meta Deskripsi"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_desc_id"
                                            value={params.meta_desc_id || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Deskripsi terlebih dahulu'
                                            ]}
                                            multiline
                                            maxRows={16}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <InputLabel
                                            htmlFor="meta_desc_en"
                                            className="mb-4"
                                        >
                                            Meta Deskripsi [EN]{' '}
                                            <span className="text-danger">*</span>
                                            <Tooltip title="Teks Akan digunakan untuk seo saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                                <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                            </Tooltip>
                                        </InputLabel>
                                        <TextValidator
                                            id="meta_desc_en"
                                            placeholder="Meta Deskripsi"
                                            className="w-full"
                                            variant="outlined"
                                            onChange={handleChange}
                                            type="text"
                                            name="meta_desc_en"
                                            value={params.meta_desc_en || ''}
                                            validators={['required']}
                                            errorMessages={[
                                                'Masukkan Meta Deskripsi terlebih dahulu'
                                            ]}
                                            multiline
                                            maxRows={16}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="flex-end"
                                            className="flex-column-reverse flex-md-row"
                                        >
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    color="primary"
                                                    className="text-primary w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                    onClick={() =>
                                                        history.goBack()
                                                    }
                                                >
                                                    Batal
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    className="text-white w-full radius-6 text-capitalize py-2"
                                                    disableElevation
                                                    disabled={submit}
                                                >
                                                    {submit ? (
                                                        <CircularProgress
                                                            color="primary"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        'Simpan'
                                                    )}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </ValidatorForm>
                        )}
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default EditSertifikat;
